<template>
  <DxScrollView :use-native="true" class="stock_wrapper-manager" :style="scrollStyle">
    <div class="stock_list_holder">
      <div v-for="(product, index) in localProducts" :key="product.uuid || index" class="product-manager-item">
        <ProductSingleEditor
          :ref="`productEditor_${index}`"
          :value="product"
          :movement-date="movementDate"
          :total-area="totalArea"
          @input="updateProduct(index, $event)"
          @remove="removeProduct(product.uuid)"
          :show-save="false"
          :show-warehouse-selector="showWarehouseSelector"
          :show-unit-price="showUnitPrice"
        />
      </div>
    </div>
  </DxScrollView>
</template>

<script>
import { DxScrollView } from "devextreme-vue/scroll-view";
import ProductSingleEditor from "@/components/Mobile/ProductSingleEditor.vue";

export default {
  name: "ProductMultiManager",
  components: {
    DxScrollView,
    ProductSingleEditor,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    movementDate: {
      type: String,
      default: "",
    },
    totalArea: {
      type: Number,
      default: 0,
    },
    showWarehouseSelector: {
      type: Boolean,
      default: false,
    },
    showUnitPrice: {
      type: Boolean,
      default: false,
    },
    bottomPadding: {
      type: Number,
      default: 0,
    },
    isProductEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    scrollStyle() {
      const padding = Number.isFinite(this.bottomPadding) ? this.bottomPadding : 0;
      return padding > 0 ? { paddingBottom: `${padding}px` } : null;
    },
  },
  data() {
    return {
      localProducts: this.normalizeProducts(this.products),
    };
  },
  watch: {
    products: {
      handler(newVal) {
        this.localProducts = this.normalizeProducts(newVal);
      },
      deep: true,
    },
  },
  methods: {
    getEditorRefs() {
      const refs = Object.values(this.$refs || {});
      return refs.flatMap((ref) => (Array.isArray(ref) ? ref : [ref])).filter(Boolean);
    },
    normalizeProducts(list) {
      return (Array.isArray(list) ? list : []).map((product) => ({
        ...product,
        lot_items: Array.isArray(product?.lot_items) ? product.lot_items : [],
      }));
    },
    emitProducts() {
      this.$emit(
        "input",
        this.localProducts.map((product) => ({ ...product })),
      );
    },
    updateProduct(index, updatedProduct) {
      this.$set(this.localProducts, index, { ...updatedProduct });
      this.emitProducts();
    },
    removeProduct(uuid) {
      const index = this.localProducts.findIndex((product) => product.uuid === uuid);
      if (index !== -1) {
        this.localProducts.splice(index, 1);
        this.emitProducts();
      }
    },
    isValid() {
      const editors = this.getEditorRefs();
      if (!editors.length) {
        return true;
      }
      return editors.every((editor) => (typeof editor.isValid === "function" ? editor.isValid() : true));
    },
    validate() {
      const editors = this.getEditorRefs();
      if (!editors.length) {
        return true;
      }
      return editors.every((editor) => (typeof editor.validate === "function" ? editor.validate() : true));
    },
  },
};
</script>
